import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchLocationsByQuery } from 'shared/services/fetchLocationsByQuery';
import { ILocation } from 'shared/types/location';
import { IThunkApi } from 'shared/types/redux';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const makeAutocompleteSearch = createAsyncThunk<ILocation[], string, IThunkApiExtended>(
  'geo/locationSwitcher/autocompleteSearch',
  async (query, thunkApi) => {
    const { extra: context, rejectWithValue } = thunkApi;

    try {
      return await fetchLocationsByQuery(context, { text: query });
    } catch (e) {
      return rejectWithValue();
    }
  },
);
